module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Sending mail-13c11bfb78d71c7e2204dcdc95207c7c.svg";